import { render, staticRenderFns } from "./VCopiedToast.vue?vue&type=template&id=77627e80&"
import script from "./VCopiedToast.vue?vue&type=script&lang=js&"
export * from "./VCopiedToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports